import React from 'react';
import { Steps } from 'antd';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { CheckCircleFilled, CaretDownFilled } from '@ant-design/icons';

const customDot = (dot, { status }) => {
  switch (status) {
    case 'finish':
      return <CheckCircleFilled />;

    case 'process':
      return (
        <div style={{ color: '#000' }}>
          <CaretDownFilled />
        </div>
      );
    case 'wait':
      return dot;

    default:
      return dot;
  }
};

const JoinSteps = ({ currentStep, noCreditCard = false }) => {
  return (
    <Steps
      className="onboarding-steps-dots"
      progressDot={customDot}
      current={currentStep}
      items={[
        {
          title: <FormattedMessage defaultMessage="Create Account" />,
        },
        {
          title: <FormattedMessage defaultMessage="Set password" />,
        },
        {
          title: <FormattedMessage defaultMessage="Card details" />,
          disabled: noCreditCard,
        },
        {
          title: <FormattedMessage defaultMessage="Start podcasting" />,
        },
      ].filter((item) => !item.disabled)}
    />
  );
};

JoinSteps.propTypes = {
  currentStep: PropTypes.number,
  noCreditCard: PropTypes.bool,
};

export default JoinSteps;
